<template>
  <v-breadcrumbs v-if="isEnabledBreadcrumbs" :items="breadCrumbs" divider=">">
    <template #item="{ item }">
      <v-breadcrumbs-item :to="item.to" class="text-subtitle-2 crumb-item" exact>
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router/composables';

export default defineComponent({
  name: 'CfsUltimateBreadcrumbs',
  setup() {
    const route = useRoute();

    const isEnabledBreadcrumbs = computed(() =>
      typeof route.meta?.breadcrumb?.exact === 'undefined' ? true : route.meta.breadcrumb.exact
    );

    const breadCrumbsBasedOnMatched = computed(() =>
      route.matched
        .filter((routeOption) => routeOption.meta.breadcrumb)
        .map((routeOption) => {
          const { routeName, label, query = {} } = routeOption.meta.breadcrumb;
          const breadcrumbLabel = typeof label === 'function' ? label(route.params) : label;
          const breadcrumbQuery = typeof query === 'function' ? query(route.query) : query;
          return {
            to: { name: routeName, params: route.params, query: breadcrumbQuery },
            text: breadcrumbLabel,
          };
        })
    );

    const breadCrumbBasedOnQueryTab = computed(() => {
      if (!('tab' in route.query)) return [];
      return [
        {
          to: { name: route.name, query: { ...route.query, tab: route.query.tab } },
          text: route.query.tab,
        },
      ];
    });

    const breadCrumbs = computed(() => {
      return [...breadCrumbsBasedOnMatched.value, ...breadCrumbBasedOnQueryTab.value];
    });
    return {
      breadCrumbs,
      isEnabledBreadcrumbs,
    };
  },
});
</script>
